// extracted by mini-css-extract-plugin
export default {"confirmation":"ClientAlreadyExists_confirmation__WxJGt","buttonGrid":"ClientAlreadyExists_buttonGrid__AdNVk"};